// ============================================================
// 都営地下鉄/さくらトラム 鉄道 GTFS-RT VehiclePosition ポーリング
// ============================================================
// odpt:Train (区間情報) と違い、列車の本物の緯度経度が取れる。

import { transit_realtime } from 'gtfs-realtime-bindings'
import type { Entity } from '../types'
import { POLL_TRAIN_MS } from '../config'
import { fetchToeiTrainVehiclePositions } from './odpt-client'

export type TrainHandler = (trains: Entity[]) => void

export class TrainGtfsRtPoller {
  private timer: ReturnType<typeof setInterval> | null = null
  private handlers = new Set<TrainHandler>()
  private last: Entity[] = []
  private inFlight = false

  start(): void {
    if (this.timer) return
    void this.pollOnce()
    this.timer = setInterval(() => void this.pollOnce(), POLL_TRAIN_MS)
  }

  stop(): void {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  subscribe(h: TrainHandler): () => void {
    this.handlers.add(h)
    if (this.last.length) h(this.last)
    return () => this.handlers.delete(h)
  }

  private async pollOnce(): Promise<void> {
    if (this.inFlight) return
    this.inFlight = true
    try {
      const buf = await fetchToeiTrainVehiclePositions()
      const feed = transit_realtime.FeedMessage.decode(buf)
      const entities: Entity[] = []
      for (const e of feed.entity) {
        const v = e.vehicle
        if (!v?.position) continue
        const lat = v.position.latitude
        const lon = v.position.longitude
        if (lat == null || lon == null) continue
        const routeId = v.trip?.routeId ?? ''
        const tripId = v.trip?.tripId ?? ''
        const vehId = v.vehicle?.id ?? e.id ?? ''
        const label = (v.vehicle?.label ?? '').trim() || routeId || '都営線'
        entities.push({
          id: `train:${vehId}:${tripId}`,
          kind: 'train',
          lat,
          lon,
          moving: (v.position.speed ?? 0) > 0.5,
          bearing: v.position.bearing ?? undefined,
          label,
        })
      }
      this.last = entities
      this.handlers.forEach((h) => h(entities))
    } catch (err) {
      console.warn('[train-gtfs-rt-poller] failed', err)
    } finally {
      this.inFlight = false
    }
  }
}
